module.exports = __webpack_public_path__ + "img/pose.ccbc57de.jpg";